var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCircleCancel = function SvgCircleCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09 0a7.091 7.091 0 1 1 .001 14.183A7.091 7.091 0 0 1 7.09 0zm0 1.182A5.909 5.909 0 1 0 7.092 13 5.909 5.909 0 0 0 7.09 1.182zm-1.505 3.42 1.671 1.67 1.672-1.67a.591.591 0 0 1 .836.835L8.092 7.108 9.764 8.78c.23.23.23.605 0 .836a.593.593 0 0 1-.836 0L7.256 7.944l-1.67 1.672a.59.59 0 1 1-.836-.836l1.67-1.672-1.67-1.67a.59.59 0 0 1 .835-.836z"
  })));
};

export default SvgCircleCancel;